import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import 'jspdf-autotable';
import "./helper/i18n.js"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);


